/* eslint-disable no-undef */
import { showGlobalAlert } from "../../commonComponent/useGlobalAlert";
import webHttpService from "../webHttpService";
export async function getSimilarProduct(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getSimilarProduct`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function getFavourites(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getFavourites`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function likeOffer(id) {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/likeOffer/${id}`
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function followKeywords(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/followKeywords`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function getFAQ(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getFAQ`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function getMyWalletTransactions(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getMyWalletTransactions`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function getMyWallet() {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/getMyWallet`
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export const getCategoryQuestions = async (formData) => {
  const response = await webHttpService.post(
    `${process.env.REACT_APP_APIENDPOINT}/user/getCategoryQuestions`,
    formData
  );

  return response.data;
};

export const getHelpCategories = async (formData) => {
  const response = await webHttpService.get(
    `${process.env.REACT_APP_APIENDPOINT}/user/getHelpCategories?search=${formData.search}&language=${formData.language}`
  );

  return response.data;
};

export const getMyFollowers = async (formData) => {
  const response = await webHttpService.post(
    `${process.env.REACT_APP_APIENDPOINT}/user/getMyFollowers`,
    formData
  );

  return response.data;
};

export async function getUserFollowers(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getUserFollowers`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export const getMyFollowings = async (formData) => {
  const response = await webHttpService.post(
    `${process.env.REACT_APP_APIENDPOINT}/user/getMyFollowings`,
    formData
  );

  return response.data;
};

export async function getUserFollowings(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getUserFollowings`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function followUser(id) {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/followUser/${id}`
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function blockUser(id) {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/blockUser/${id}`
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export const getKeywords = async (formData) => {
  const response = await webHttpService.post(
    `${process.env.REACT_APP_APIENDPOINT}/user/getKeywords`,
    formData
  );

  return response.data;
};

export async function getComments(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getComments`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function deleteKeyword(id) {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/deleteKeyword/${id}`
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function getNotificationList(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getNotificationList`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function readNotification(id) {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/readNotification/${id}`
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

// FIREBASE-ZERO 6F: notification bell count from Mongo/API. Replaces the
// Firestore "notificationCounts" mirror read in the header bell. data.results
// .count is the authoritative unread UserNotification count (same semantic as
// the old Firestore notificationCounts.unreadCount). SILENT on error (NO global
// alert) so the bell degrades quietly to its fallback/last value. Same auth as
// every other webHttpService call (x-auth-token-user injected by the instance).
export async function getNotificationCount() {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/getNotificationCount`
    );

    return { data };
  } catch (error) {
    return { error };
  }
}

export async function getFCMToken(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getFCMToken`, formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function updateFCMToken(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/updateFCMToken`, formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function updateShopCenter(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/updateShopCenter`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}
export async function validShopName(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/checkValidShopName`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function getBlockedUserList(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getMyBlockList`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function sendMessageNotification(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/sendMessageNotification`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function uploadImage(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/uploadImage`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function updateLocation(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/updateLocation`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function UnblockUser(id) {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/blockUser/${id}`
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export const getAnouncements = async () => {
  const response = await webHttpService.get(
    `${process.env.REACT_APP_APIENDPOINT}/user/getAnnouncements`
  );

  return response.data;
};

export const getAnouncementDetails = async (id) => {
  const response = await webHttpService.get(
    `${process.env.REACT_APP_APIENDPOINT}/user/getAnnouncementDetail/${id}`
  );

  return response.data;
};

export const getOffers = async (formData) => {
  const response = await webHttpService.post(
    `${process.env.REACT_APP_APIENDPOINT}/user/getOffers`,
    formData
  );

  return response.data;
};

export async function shareYourThought(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/shareThought`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function getPurchaseRequests(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/getMyProductsAllRequests`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}
export async function manageProductStatus(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/changeProductStatus`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function submitResponse(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/submitResponse`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export const getAnswer = async (id) => {
  const response = await webHttpService.get(
    `${process.env.REACT_APP_APIENDPOINT}/user/getAnswer/${id}`
  );

  return response.data;
};

export async function changeLanguage(formData) {
  try {
    const { data } = await webHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}/user/changeLanguage`,
      formData
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function closeEmailPopup() {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/closeEmailPopup`
    );

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}

export async function getTransactionDetail(id) {
  try {
    const { data } = await webHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}/user/getTransactionDetail/${id}`
    );
    console.log(data);

    return { data };
  } catch (error) {
    if (error.response) showGlobalAlert(error.response.data.message);
    return { error };
  }
}
